var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDolar1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.95 48.51c0 23.073 18.772 41.846 41.845 41.846S91.64 71.583 91.64 48.51c0-23.073-18.772-41.845-41.845-41.845S7.95 25.437 7.95 48.51zm76.083 0c0 18.879-15.36 34.237-34.238 34.237S15.558 67.389 15.558 48.51c0-18.877 15.359-34.236 34.237-34.236 18.879 0 34.238 15.359 34.238 34.236z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.23 25.68v4.458c-4.429 1.57-7.609 5.798-7.609 10.759 0 6.291 5.12 11.412 11.412 11.412a3.808 3.808 0 0 1 3.804 3.804 3.808 3.808 0 0 1-3.804 3.803c-1.625 0-3.38-1.021-4.939-2.877a3.805 3.805 0 0 0-5.824 4.896c2.034 2.418 4.425 4.104 6.96 4.954v4.44a3.804 3.804 0 1 0 7.607 0v-4.458c4.428-1.571 7.61-5.8 7.61-10.758 0-6.294-5.12-11.413-11.414-11.413a3.808 3.808 0 0 1-3.804-3.803 3.81 3.81 0 0 1 3.804-3.806c1.348 0 2.771.689 4.114 1.989a3.805 3.805 0 0 0 5.292-5.467c-1.93-1.868-3.863-2.925-5.602-3.502V25.68a3.805 3.805 0 0 0-3.804-3.805 3.805 3.805 0 0 0-3.804 3.805z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDolar1);
export default __webpack_public_path__ + "static/media/dolar 1.f5f8b18ed796e4d93a97513dc91482ed.svg";
export { ForwardRef as ReactComponent };